<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-ticket-scenic">
    <header class="ren-decoration-cp-scenic-ticket-scenic__head">
      <strong>{{ title }}</strong>
    </header>
    <div class="ren-decoration-cp-scenic-ticket-scenic__card">
      <div class="ren-decoration-cp-scenic-ticket-scenic__avatar" aria-hidden="true">{{ glyph }}</div>
      <div class="ren-decoration-cp-scenic-ticket-scenic__body">
        <b class="ren-decoration-cp-scenic-ticket-scenic__name">{{ name }}</b>
        <div v-if="showRating || showDistance" class="ren-decoration-cp-scenic-ticket-scenic__row">
          <span v-if="showRating && scenic.hasRank" class="ren-decoration-cp-scenic-ticket-scenic__rating">
            ★ {{ scenic.rank }}
          </span>
          <span v-else-if="showRating" class="ren-decoration-cp-scenic-ticket-scenic__no-score">暂无评分</span>
          <span v-if="showDistance && scenic.distanceKm">距您 {{ scenic.distanceKm }}km</span>
        </div>
        <div v-if="showBusinessHours" class="ren-decoration-cp-scenic-ticket-scenic__row">
          <b :class="{ 'is-open': scenic.businessStatusCode === 'OPEN' }">{{ statusText }}</b>
          <span>{{ scenic.hours }}</span>
        </div>
      </div>
      <div v-if="showLocation" class="ren-decoration-cp-scenic-ticket-scenic__tools">
        <span class="ren-decoration-cp-scenic-ticket-scenic__tool">导</span>
        <span class="ren-decoration-cp-scenic-ticket-scenic__tool">话</span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import {
  SAMPLE_SCENIC,
  scenicStatusText
} from '../../scenic-preview-data'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const scenic = computed(() => ({
  ...SAMPLE_SCENIC,
  ...(stringValue(props.component.props?.name) ? { name: stringValue(props.component.props?.name) } : {})
}))
const name = computed(() => scenic.value.name)
const glyph = computed(() => (name.value || '景').trim().slice(0, 1))
const statusText = computed(() => scenicStatusText(scenic.value.businessStatusCode))
const title = computed(() => stringValue(props.component.props?.title, '适用商户'))
const showRating = computed(() => booleanValue(props.component.props?.showRating, true))
const showBusinessHours = computed(() => booleanValue(props.component.props?.showBusinessHours, true))
const showLocation = computed(() => booleanValue(props.component.props?.showLocation, true))
const showDistance = computed(() => booleanValue(props.component.props?.showDistance, true))
</script>

<style scoped>
.ren-decoration-cp-scenic-ticket-scenic {
  display: grid;
  gap: 8px;
  padding: 12px;
  background: var(--ren-theme-card);
}
.ren-decoration-cp-scenic-ticket-scenic__head strong {
  color: var(--ren-theme-text);
  font-size: 14px;
}
.ren-decoration-cp-scenic-ticket-scenic__card {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ren-decoration-cp-scenic-ticket-scenic__avatar {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: var(--ren-theme-radius);
  color: #fff;
  background: linear-gradient(135deg, var(--ren-theme-primary), var(--ren-theme-accent));
  font-size: 18px;
}
.ren-decoration-cp-scenic-ticket-scenic__body {
  flex: 1;
  min-width: 0;
  display: grid;
  gap: 5px;
}
.ren-decoration-cp-scenic-ticket-scenic__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ren-theme-text);
  font-size: 13px;
}
.ren-decoration-cp-scenic-ticket-scenic__row {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--ren-theme-muted);
  font-size: 11px;
}
.ren-decoration-cp-scenic-ticket-scenic__rating {
  color: var(--ren-theme-accent);
}
.ren-decoration-cp-scenic-ticket-scenic__row b {
  font-weight: 600;
}
.ren-decoration-cp-scenic-ticket-scenic__row b.is-open {
  color: var(--ren-theme-primary);
}
.ren-decoration-cp-scenic-ticket-scenic__tools {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ren-decoration-cp-scenic-ticket-scenic__tool {
  display: inline-grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--ren-theme-primary);
  color: #fff;
  font-size: 10px;
}
</style>
